<template>

  <div class="admin-body">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>股东设置</el-breadcrumb-item>
        <el-breadcrumb-item>股东管理</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <el-row style="padding: 15px">
      <el-row class="main">
        <el-row style="padding-bottom: 10px;">
          <el-col :span="24" align="left"style="width: 50%">&nbsp;
            <el-input
              style="width: 200px"
              placeholder="请输入"
              v-model="key"
              clearable>
            </el-input>
            <el-button type="primary" @click="getstart()">开始查询</el-button>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" style="text-align: right;width: 50%">
            <el-button type="primary" @click="addfcun">新增</el-button>
            <el-button type="danger" @click="deletesel">踢出</el-button>
          </el-col>
        </el-row>
        <el-table
          border
          ref="multipleTable"
          @selection-change="handleSelectionChange"
          align="left"
          :data="tableData"
          style="width: 100%">
          <el-table-column
            type="selection"
            fixed="left"
            width="50">
          </el-table-column>
          <el-table-column
            type="index"
            label="序号"
            width="50">
          </el-table-column>
<!--          <el-table-column-->
<!--            prop="user_id"-->
<!--            fixed="left"-->
<!--            label="用户ID"-->
<!--          >-->
<!--          </el-table-column>-->
          <el-table-column
            prop="nickname"
            label="昵称">
          </el-table-column>
          <el-table-column
            prop="phone"
            label="手机号">
          </el-table-column>
          <el-table-column
            prop="balance"
            label="余额">
          </el-table-column>
           <el-table-column
            prop="zfb_account"
            label="绑定支付宝账号">
          </el-table-column>
          <el-table-column
            prop="shareholder"
            label="是否是股东">
            <template slot-scope="scope">
              {{scope.row.shareholder=1?'是' :'否'}}
            </template>
          </el-table-column>
          <el-table-column
            prop="gdtime"
            label="成为股东时间">
            <template slot-scope="scope">
              {{formatDate(scope.row.gdtime)}}            </template>
          </el-table-column>
            <el-table-column
            prop="regtime"
            label="注册时间">
              <template slot-scope="scope">
                {{formatDate(scope.row.regtime)}}
              </template>
          </el-table-column>

          <el-table-column
            label="操作"
            width="100">
            <template slot-scope="scope">
              <el-button @click="changevaluestate(scope.row.user_id,2)" size="small" type="text">踢出</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row style="margin-top: 20px">
          <el-col :xs="0" :sm="8" :md="8" :lg="8">
            &nbsp;&nbsp;
            <!--<el-button type="primary" @click="">批量导入</el-button>-->
            <!--<el-button type="primary" @click="">批量导出</el-button>-->
          </el-col>
          <el-col :xs="24" :sm="15" :md="15" :lg="15">
            <el-pagination
              style="text-align: right"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="datatotal">
            </el-pagination>
          </el-col>

        </el-row>
      </el-row>
    </el-row>

    <el-dialog title="编辑" :visible.sync="editVisible" width="380px" :modal-append-to-body="false">
      <el-form :model="editdata"  :rules="editrules" ref="editdata">
        <el-form-item label="充值名称" :label-width="formLabelWidth" prop="recharge_name">
          <el-input clearable v-model="editdata.recharge_name" auto-complete="off" placeholder="请输入充值名称" required></el-input>
        </el-form-item>
        <el-form-item label="充值金额" :label-width="formLabelWidth" prop="recharge_num">
          <el-input type="number" clearable v-model="editdata.recharge_num" auto-complete="off" placeholder="请输入充值金额(元)" required></el-input>
        </el-form-item>
        <el-form-item label="终端返现" :label-width="formLabelWidth" prop="recharge_user_givenum">
          <el-input type="number" clearable v-model="editdata.recharge_user_givenum" auto-complete="off" placeholder="请输入终端赠送金额(元)" required></el-input>
        </el-form-item>
        <el-form-item label="企业返现" :label-width="formLabelWidth" prop="recharge_enterprise_givenum">
          <el-input type="number" clearable v-model="editdata.recharge_enterprise_givenum" auto-complete="off" placeholder="请输入企业赠送金额(元)" required></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitedit('editdata')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="新增" :visible.sync="addVisible" width="380px" :modal-append-to-body="false">
      <el-row style="margin-bottom: 10px">
        <el-input placeholder="输入用户姓名" v-model="memberselectkey" class="input-with-select" @clear="getUserList()" clearable>
          <el-button slot="append" icon="el-icon-search" @click="getUserList()"></el-button>
        </el-input>
      </el-row>
      <el-table
        border
        align="left"
        :data="userData"
        style="width: 100%">
        <el-table-column
          prop="user_id"
          label="用户ID"
          fixed="left"
          width="60">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="手机号码"
          width="100">
        </el-table-column>
        <el-table-column
          prop="nickname"
          label="昵称">
        </el-table-column>
        <el-table-column
          label="">
          <template slot-scope="scope">

            <el-button @click="submit(scope.row.user_id)" size="small" type="text">选择</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-row style="margin-top: 10px">
        <el-pagination
          small
          background
          @size-change="memberhandleSizeChange"
          @current-change="memberhandleCurrentChange"
          :current-page=" membercurrentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size=" memberpagesize"
          layout="prev, pager, next"
          :total="membertotal">
        </el-pagination>
      </el-row>
      <!--<el-form :model="adddata"  :rules="addrules" ref="adddata">-->
        <!--<el-form-item label="选择用户" :label-width="formLabelWidth" >-->
          <!--<el-select v-model="userValue" filterable placeholder="请选择用户" >-->
          <!--<el-option-->
          <!--v-for="item in userData"-->
          <!--:key="item.user_id"-->
          <!--:label="item.nickname"-->
          <!--:value="item.user_id">-->
          <!--</el-option>-->
          <!--</el-select>-->
        <!--</el-form-item>-->
      <!--</el-form>-->
      <!--<div slot="footer" class="dialog-footer">-->
        <!--<el-button @click="addVisible = false">取 消</el-button>-->
        <!--<el-button type="primary" @click="submit(userValue,1)">确 定</el-button>-->
      <!--</div>-->
    </el-dialog>

    <template><span v-loading.fullscreen.lock="fullscreenLoading"></span></template>
  </div>
</template>

<script>
  export default {
    name: "Partner",
    mounted() {
      if(!this.$store.state.login.in){
        this.$router.push({ name: "login", params: { userId: 123 }})
      }
      this.getstart()
    },
    data() {
      return {
        memberselectkey: '',
        memberpagesize:10,
        membercurrentPage:1,
        membertotal:0,
        userValue:'',
        userData:[],
        dataa: [],
        fullscreenLoading: false,
        tableData: [],
        pagesize:10,
        currentPage:1,
        key:'',
        datatotal:0,
        //表格
        multipleSelection: [],
        formLabelWidth: '80px',
        editVisible:false,
        editdata:{
          recharge_name: '',
          recharge_num:'',
          recharge_user_givenum:'',
          recharge_enterprise_givenum:'',
        },
        editrules: {
          recharge_name: { required: true, message: '必填', trigger: 'blur' },
          recharge_num: { required: true, message: '必填', trigger: 'blur' },
          recharge_user_givenum: { required: true, message: '必填', trigger: 'blur' },
          recharge_enterprise_givenum: { required: true, message: '必填', trigger: 'blur' },
        },
        addVisible:false,
        adddata:{
          recharge_name: '',
          recharge_num:'',
          recharge_user_givenum:'',
          recharge_enterprise_givenum:'',
        },
        addrules: {
          recharge_name: { required: true, message: '必填', trigger: 'blur' },
          recharge_num: { required: true, message: '必填', trigger: 'blur' },
          recharge_user_givenum: { required: true, message: '必填', trigger: 'blur' },
          recharge_enterprise_givenum: { required: true, message: '必填', trigger: 'blur' },
        },

      }
    },
    computed:{
    },
    watch:{
    },
    methods: {
      getstart() {
        let thi = this
        thi.fullscreenLoading = true
        this.$http.post(global.posturl.host + global.posturl.listShareholder, {
          page : thi.currentPage,
          pageSize : thi.pagesize,
          key: thi.key,
        }).then(function (response) {
          console.log(response.data)
          var qcode = response.data.code
          var qmsg = response.data.msg
          var qdata = response.data.data
          var qtotal = response.data.Total
          if(qcode==200){
            thi.tableData=qdata
            thi.datatotal=qtotal
          }
          thi.fullscreenLoading = false
        }).catch(function (error) {
          console.log(error)
        });
      },
      getUserList(){
        let thi = this
        thi.addVisible=true
        thi.fullscreenLoading = true
        this.$http.post(global.posturl.host + global.posturl.userList, {
          page : thi.membercurrentPage,
          pageSize : thi.memberpagesize,
          key: thi.memberselectkey,
        }).then(function (response) {
          console.log(response.data)
          var qcode = response.data.code
          var qmsg = response.data.msg
          var qdata = response.data.data
          var qtotal = response.data.Total
          if(qcode==200){
            thi.userData=qdata,
              thi.membertotal = response.data.Total
          }
          thi.fullscreenLoading = false
        }).catch(function (error) {
          console.log(error)
        });
      },
      //修改
      editvalue(row){
        this.editdata=row
        this.editVisible=true
      },
      //提交编辑
      submitedit(formName){
        let thi = this
        thi.$refs[formName].validate((valid) => {
          if (valid) {
            thi.fullscreenLoading = true
            thi.$http.post(global.posturl.host + global.posturl.rechargeedit,
              thi.editdata
            ).then(function (response) {
              var qcode = response.data.code
              var qmsg = response.data.msg
              var qdata = response.data.data
              if(qcode==200){
                thi.editVisible=false
              }else{
                thi.$message({
                  type: 'warning',
                  message: qmsg
                });
              }
              thi.getstart()
            }).catch(function (error) {
              console.log(error)
            });
          } else {
            return false;
          }
        });
      },
      addfcun(){
        this.getUserList()
        // var data={
        //   recharge_name: '',
        //   recharge_num:'',
        //   recharge_user_givenum:'',
        //   recharge_enterprise_givenum:'',
        // }
        // this.adddata=data
        // this.addVisible=true
      },
      //提交新增
      submit(uid){
        let thi = this
            thi.fullscreenLoading = true
            thi.$http.post(global.posturl.host + global.posturl.addShareholder,{
                user_id:uid,
              shareholder:1
              }).then(function (response) {
              console.log(response.data)
              var qcode = response.data.code
              var qmsg = response.data.msg
              var qdata = response.data.data
              if(qcode==200){
                thi.addVisible=false
              }else{
                thi.$message({
                  type: 'warning',
                  message: qmsg
                });
              }
              thi.getstart()
            }).catch(function (error) {
              console.log(error)
            });
      },
      //选择展示数量
      memberhandleSizeChange(val) {
        this.memberpagesize=val
        this.getUserList()
      },
      //跳转页面
      memberhandleCurrentChange(val) {
        this.membercurrentPage=val
        this.getUserList()
      },
      //删除提示
      changevaluestate(id,state) {
        var heeh = '该'
        if(id.length>1){
          heeh='这些'
        }
        let thi = this
        thi.$confirm('此操作将踢出'+heeh+'用户, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error'
        }).then(() => {
          thi.submitchangestate(id,state)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'+caozuo
          });
        });
      },
      //状态改变
      submitchangestate(id,state) {
        console.log(id,state)
        let thi = this
        thi.fullscreenLoading = true
        this.$http.post(global.posturl.host+global.posturl.removeShareholder, {
          user_id: id,
          shareholder : state
        }).then(function (response) {
          console.log(response.data)
          var qcode = response.data.code
          if(qcode==200){
            thi.getstart()
          }
        }).catch(function (error) {
          console.log(error)
        });
      },
      //批量删除
      deletesel() {
        if(this.multipleSelection.length==0){
          this.$message({
            type: 'warning',
            message: '请选择要踢出的分类!'
          });
          return
        }else{
          var ids = '';
          this.multipleSelection.forEach(function(avalue,aindex,aarr){
            if(aindex==0){
              ids = avalue.user_id
            }else {
              ids = ids+','+avalue.user_id
            }
          });
          this.changevaluestate(ids,2)
        }

      },


      //选择展示数量
      handleSizeChange(val) {
        this.pagesize=val
        this.getstart()
      },
      //跳转页面
      handleCurrentChange(val) {
        this.currentPage=val
        this.getstart()
      },


      //格式化日期
      formatDate (date) {
        if(!date){
          return "无"
        }
        Date.prototype.toLocaleString = function() {
          return this.getFullYear() + "-" + (this.getMonth() + 1) + "-" + this.getDate() + " " + this.getHours() + ":" + this.getMinutes() + ":" + this.getSeconds();
        };
        var unixTimestamp = new Date(date * 1000)
        return unixTimestamp.toLocaleString();
      },
      //多选
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },

    }
  }
</script>

<style scoped>
  .admin-body{
    /*background-color: white;*/
    width: 100%;
  }
  .main{
    background-color: white;
    min-height: 500px;
    padding: 10px;
    border: #EDEDED 1px solid;
    border-radius: 5px;
  }
  .block{
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/page/partner/Partner.vue